import axios from "axios";
import { defineStore } from "pinia";

export const useEmailStore = defineStore("email", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    response: {
      status: null,

    }
  }),

  actions: {
    async sendEmail(data) {
      try {
        const response = await axios.post(`${this.apiUrl}/api/v1/send-email`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        this.response = {
          status: response.status,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
        };
      }
    },
  },
});
